import { useContext, useState, useEffect } from 'react'

import { FronthubContext } from 'front-hub-context-api'

import { isPromise, isFunction } from '../../../../core/object'
import { parseToSafeJson } from '../../../../core/security'

export default function useHostContext() {
  const { context } = useContext(FronthubContext)
  const [contextValue, setContextValue] = useState(() => {
    if (isPromise(context)) return context

    if (isFunction(context)) return context()

    return context
  })

  useEffect(() => {
    if (isPromise(contextValue)) {
      contextValue.then(setContextValue)
    }
  }, [context])

  return contextValue ? { ...parseToSafeJson(contextValue) } : {}
}
